import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import ROUTES from "../../route";
import {useUser} from "../State/UserContext";

const Logout = () => {
    const navigate = useNavigate()
    const {setUser} = useUser()

    useEffect(() => {
        localStorage.removeItem('api_token');
        setUser(null);
        navigate(ROUTES.DEFAULT)
    }, []);
    return(
        <>
        </>
    )
}

export default Logout;